// Admin-E-Mail über Environment Variable (Railway)
// REACT_APP_ADMIN_EMAIL wird beim Build gesetzt
export const ADMIN_UID   = process.env.REACT_APP_ADMIN_EMAIL || 'spahija@live.at';
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || 'spahija@live.at';

export const isAuthorizedAdmin = (user) => {
  if (!user) return false;
  if (user.email && user.email.toLowerCase() === ADMIN_EMAIL.toLowerCase()) return true;
  if (user.uid  && user.uid.toLowerCase()   === ADMIN_EMAIL.toLowerCase()) return true;
  return false;
};

export const validateAdminAccess = (userOrUid) => {
  if (!userOrUid) return false;
  if (typeof userOrUid === 'string') return userOrUid.toLowerCase() === ADMIN_EMAIL.toLowerCase();
  return isAuthorizedAdmin(userOrUid);
};
